import { IPropertyEditable } from "../../../../base/domain/system/edit";
import {
  ILinkedScriptExecuteBehavior,
} from "../../../../documaker/domain/format/objects";
import { IFormatObjectEditable } from "../IFormatObjectEditable";
import { IFormatSpecification } from "../IFormatSpecification";
import { IScriptLinkObject } from "../objects";
import {
  IScriptExecuteBehaviorPropertyEditable,
} from "../properties";
import { AbstractTextDrawableObjectEditor } from "./AbstractTextDrawableObjectEditor";

export class ScriptLinkObjectEditor extends AbstractTextDrawableObjectEditor<IScriptLinkObject> implements
IScriptExecuteBehaviorPropertyEditable {
  constructor(source: IScriptLinkObject | ScriptLinkObjectEditor, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
    this._name = this.createNamePropertyEditor();
    this._textStyle = this.createTextStylePropertyEditor(s => false);
    this._fontSizeAutoAdjustBehavior = this.createFontSizeAutoAdjustBehaviorPropertyEditor(s => false);
    // InputRuleBehaviorはNone固定なのでPropetyEditorは用意しない.(必要になったら追加する事.)
    this._scriptExecuteBehavior = this.createPropertyEditor(s => s.scriptExecuteBehavior, (s, v) => s.scriptExecuteBehavior = v);
  }

  protected _scriptExecuteBehavior: IPropertyEditable<ILinkedScriptExecuteBehavior>;

  scriptExecuteBehavior(): IPropertyEditable<ILinkedScriptExecuteBehavior> {
    return this._scriptExecuteBehavior;
  }

  getTypeName(): string {
    return "外部処理";
  }

  clone(): IFormatObjectEditable {
    return new ScriptLinkObjectEditor(this);
  }
}
